import React, { useEffect, useState } from 'react';
import Card from 'react-bootstrap/Card';
import * as rstm from 'react-simple-tree-menu';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { Tree } from '../../../common/components/Tree/Tree';
import { GetDictionaryDto as Dictionary } from '../../../common/spdCore/autogenerated/spdApiClient';
import { GetDictionaryTypeDto as DictionaryType } from '../../../common/spdCore/autogenerated/spdApiClient/models/GetDictionaryTypeDto';
import { useNotifications } from '../../../common/hooks/useNotifications';

const mapTreeItem: (
  key?: string,
  id?: string,
  dictionaryTypeId?: string,
  label?: string,
  shortname?: string,
  systemNumber?: number,
  valueEn?: string,
  editable?: boolean,
) => rstm.TreeNodeInArray = (
  key = '',
  id = undefined,
  dictionaryTypeId = undefined,
  label = '',
  shortname = '',
  systemNumber = undefined,
  valueEn = '',
  editable = false,
) => ({
  key: key,
  id: id,
  dictionaryTypeId: dictionaryTypeId,
  label: label,
  shortname: shortname,
  systemNumber: systemNumber,
  valueEn: valueEn,
  editable: editable,
  nodes: undefined,
});

const mapDictChildren: (
  id: string | undefined,
  rootLevel: boolean,
  data: Dictionary[],
) => rstm.TreeNodeInArray[] = (id, rootLevel, data) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let dicChildren: any[] = [];

  if (rootLevel) {
    dicChildren = data.filter(
      dict => dict.dictionaryType.id === id && !dict.parentId,
    );
  } else {
    dicChildren = data.filter(dict => dict.parentId === id);
  }

  return dicChildren.map(dic => ({
    ...mapTreeItem(
      dic.id,
      dic.id,
      dic.dictionaryType.id,
      dic.shortname?.length > 0 ? ` - ${dic.value}` : dic.value,
      dic.shortname,
      dic.systemNumber,
      dic.valueEn,
      true,
    ),
    nodes: mapDictChildren(dic.id, false, data),
  }));
};

export const DictionariesTreeView: React.FC = () => {
  const spd = useSpdCore();
  const notifications = useNotifications();

  const [dataDict, setDataDict] = useState<Dictionary[]>([]);
  const [dataDictType, setDataDictType] = useState<DictionaryType[]>([]);
  const [treeData, setTreeData] = useState<rstm.TreeNodeInArray[]>([]);

  useEffect(() => {
    spd.dictionaries
      .getActive()
      .then(dataDict => {
        setDataDict(dataDict);
      })
      .catch(errorResponse => {
        console.error(errorResponse);
      });
    spd.dictionaryTypes
      .getAll()
      .then(dataDictType => {
        setDataDictType(dataDictType);
      })
      .catch(errorResponse => {
        console.error(errorResponse);
      });
  }, [spd, notifications]);

  useEffect(() => {
    setTreeData(
      dataDictType.map(dict => ({
        ...mapTreeItem(
          dict.id,
          undefined,
          dict.id,
          dict.name,
          '',
          undefined,
          '',
          false,
        ),
        nodes: mapDictChildren(dict.id, true, dataDict),
      })),
    );
  }, [dataDict, dataDictType]);

  const handleRefresh = () => {
    spd.dictionaries
      .getActive()
      .then(dataDict => {
        setDataDict(dataDict);
      })
      .catch(errorResponse => {
        console.error(errorResponse);
      });
  };

  return (
    <Card className="main-card">
      <Card.Body className="m-3">
        <Card.Title className="pb-3">Słowniki</Card.Title>
        <Tree
          treeData={treeData}
          variant="dictionary"
          onUpdate={handleRefresh}
        />
      </Card.Body>
    </Card>
  );
};
